import React from "react";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    langsWrap: {
        display: "inline-flex",
        alignItems: "center",
    },
    reactCountryFlag: {
        fontSize: "1.5rem",
        borderRadius: "50%",
    },
    toolbarRoundedIcon: {},
}));

const LangSwitcher = () => {
    const classes = useStyles();
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        localStorage.setItem("lang", lng);
        i18n.changeLanguage(lng);
        window.location.reload();
    };

    document.documentElement.setAttribute("lang", i18n.language);

    return (
        <div className={classes.langsWrap}>
            {i18n.language === "en" ? (
                <IconButton
                    variant="text"
                    className={classes.toolbarRoundedIcon}
                    aria-label="polish"
                    onClick={() => changeLanguage("pl")}
                >
                    <ReactCountryFlag
                        countryCode="PL"
                        svg
                        cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                        cdnSuffix="svg"
                        title="PL"
                        className={classes.reactCountryFlag}
                    />
                </IconButton>
            ) : (
                <IconButton
                    variant="text"
                    className={classes.toolbarRoundedIcon}
                    aria-label="polish"
                    onClick={() => changeLanguage("en")}
                >
                    <ReactCountryFlag
                        countryCode="GB"
                        svg
                        cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                        cdnSuffix="svg"
                        title="EN"
                        className={classes.reactCountryFlag}
                    />
                </IconButton>
            )}
        </div>
    );
};

export default LangSwitcher;
